export const DEFAULT_PORT = 3001;
export const isProduction = process.env.NODE_ENV === "production";
export const GAME_ID = "mosaic";
